import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { Holiday } from '../../models/calendar/holiday';
import { CalendarBuilder } from '../../models/builders/calendar.builder';
import { isArray } from 'util';

const saveHolidaysBody = (holidays: Holiday[]) => {
  return (isArray(holidays))
    ? holidays.map(holiday => ({
      date: holiday.date
    }))
    : [];
};

@Injectable()
export class HolidayApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }calendar`;
  }

  getHolidays(year: number, workingShift: string) {
    const params = new HttpParams().append('year', year.toString())
      .append('workingShift', workingShift);

    return this.httpClient.get(`${ this.apiUrl }/holidays`, { params })
      .pipe(
        map(CalendarBuilder.buildHolidaysFromList)
      );
  }

  saveHolidays(year: number, workingShift: string, holidays: Holiday[]) {
    return this.httpClient.put(`${ this.apiUrl }/holidays/${ year }/${ workingShift }`,  { holidays: saveHolidaysBody(holidays) });
  }

  deleteHoliday(holiday: Holiday) {
    return this.httpClient.delete(`${ this.apiUrl }/holidays/${ holiday.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/holiday-api.service.ts